/**
 * ACCOUNT-SUBSCRIPTIONS
 * List of subscriptions of the active account (add, edit, delete)
 */

import { connect } from "react-redux"
import { WithTranslation, withTranslation } from "react-i18next"
import { store } from "@/index"
import Button from "@/components/button"
import Card from "@/components/card"
import Space from "@/components/space"
import SubscriptionEditorWidget from "@/widgets/subscription-editor.widget"
import { AccountState } from "@/redux/account.types"
import { accountStatus } from "@/redux/account.actions"
import { subscriptionAdd, subscriptionRemove, subscriptionDestroy } from "@/redux/subscription.actions"
import { Subscription, SubscriptionState } from "@/redux/subscription.types"
import { STATUS_SAVED, STATUS_SAVE_ERROR, STATUS_SAVING } from "@/redux/_status.types"

interface StateProps extends WithTranslation {
  account: AccountState
  subscription: SubscriptionState
}

interface OwnProps {
  isWithoutHeader?: boolean //Hide title and "add" button
  selectedId?: string | null //Id of the selected subscription (colored on the left)
  onSelect?: (subscription: Subscription) => void //Clic on a subscription
}

type Props = StateProps & OwnProps

function AccountSubscriptionsWidget(props: Props) {
  const { t } = props

  //Add subscription
  function addSubscription() {
    store.dispatch(subscriptionAdd(props.account.active.id))
  }

  //Delete subscription
  async function deleteSubscription(subscriptionId: string) {
    store.dispatch(subscriptionRemove(subscriptionId))
    store.dispatch(accountStatus(STATUS_SAVING))
    const response: any = await store.dispatch(subscriptionDestroy(subscriptionId))
    store.dispatch(accountStatus(response.error ? STATUS_SAVE_ERROR : STATUS_SAVED))
  }

  return (
    <div>
      {!props.isWithoutHeader && (
        <div className="flex">
          <h3 id="subscriptions_section">{t("subscriptions")}</h3>
          <Space />
          <Button onClick={addSubscription} className="secondary" isWithBorder>
            {t("subscription_add")}
          </Button>
        </div>
      )}

      {props.subscription.list.length === 0 && <p className="grey-t">{t("account_no_active_subscription")}</p>}

      <div className="height-20" />

      {props.subscription.list.map((subscription: Subscription) => (
        <Card
          key={subscription.id}
          className={
            subscription.id === props.selectedId
              ? "border-0 border-l-8 border-solid border-idt-primary-main"
              : props.onSelect
                ? "cursor-pointer border-0 border-l-8 border-solid border-transparent hover:border-idt-primary-main/40"
                : ""
          }
          onClick={props.onSelect ? () => props.onSelect?.(subscription) : undefined}>
          <SubscriptionEditorWidget subscription={subscription} onDelete={() => deleteSubscription(subscription.id)} />
        </Card>
      ))}
    </div>
  )
}

const mapStateToProps = (state) => ({
  account: state.account,
  subscription: state.subscription
})

export default connect(mapStateToProps)(withTranslation()(AccountSubscriptionsWidget))
